import { render } from "./MetricDashboardMonthGraphic.vue?vue&type=template&id=1245273c&ts=true"
import script from "./MetricDashboardMonthGraphic.vue?vue&type=script&lang=ts"
export * from "./MetricDashboardMonthGraphic.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__